import React from 'react';
import cookies from 'react-cookies';
import { withRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import styles from './index.module.scss';
import { connectTo } from '../../utils';
import {
  logout,
  getAvailableLanguages,
  selectLanguage,
  selectBrowserLanguage,
} from '../../actions';

import {
  Header,
  Footer,
  CookieAgreement,
} from '../../components/main/index.troy';

import { GTM_TAG_ID, GTM_COOKIE_NAME } from '../../config/gtm';

import { codeFromFullCode } from '../../utils/translations';

const cookieHideKey = GTM_COOKIE_NAME;

const modifyCode = (code) => (code === 'EN' ? 'GB' : code);

class MainLayout extends React.Component {
  state = {
    hideAgreement: cookies.load(cookieHideKey),
    isTagManagerInitialized: false,
    isBrowserLanguageSent: false,
  };

  componentDidMount() {
    const { getAvailableLanguages, availableLanguages } = this.props;

    if (!availableLanguages) {
      getAvailableLanguages();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      availableLanguages,
      selectBrowserLanguage,
      isAuthenticated,
    } = this.props;
    const {
      isBrowserLanguageSent,
      hideAgreement,
      isTagManagerInitialized,
    } = this.state;

    if (!isAuthenticated && !isBrowserLanguageSent && availableLanguages) {
      selectBrowserLanguage({ isAuthenticated, languages: availableLanguages });
      this.setState({
        isBrowserLanguageSent: true,
      });
    }

    if (
      process.env.NODE_ENV === 'production' &&
      !isTagManagerInitialized &&
      hideAgreement
    ) {
      TagManager.initialize({ gtmId: GTM_TAG_ID });
      this.setState({ isTagManagerInitialized: true });
    }
  }

  onLogout = () => {
    const { logout } = this.props;
    logout();
  };

  onCookieClick = () => {
    this.setState({ hideAgreement: true });
    cookies.save(cookieHideKey, true);
  };

  onLanguageSelect = (newCode) => {
    const { selectLanguage, availableLanguages, isAuthenticated } = this.props;
    const languageInfo = availableLanguages.find(
      ({ fullCode }) => modifyCode(codeFromFullCode(fullCode)) === newCode
    );
    if (languageInfo) {
      selectLanguage({ code: languageInfo.fullCode, isAuthenticated });
    }
  };

  render() {
    const {
      children,
      isAuthenticated,
      availableLanguages,
      language,
      logout,
    } = this.props;
    const { hideAgreement } = this.state;

    return (
      <div className={styles['main-layout__wrapper']}>
        <Header
          isAuthenticated={isAuthenticated}
          onLogout={this.onLogout}
          languages={
            availableLanguages &&
            availableLanguages.map(({ fullCode, language }) => ({
              code: modifyCode(codeFromFullCode(fullCode)),
              label: language,
            }))
          }
          onLanguageSelect={this.onLanguageSelect}
          language={language && modifyCode(language)}
        />
        {children}
        <Footer isAuthenticated={isAuthenticated} logout={logout} />
        <CookieAgreement open={!hideAgreement} onOkClick={this.onCookieClick} />
      </div>
    );
  }
}

export default withRouter(
  connectTo(
    ({ translations: { availableLanguages, language } }) => ({
      availableLanguages,
      language,
    }),
    { logout, getAvailableLanguages, selectLanguage, selectBrowserLanguage },
    MainLayout
  )
);
